import { makeAutoObservable, toJS } from 'mobx'

import {
  Account,
  AppSettings,
  ClientStateValue,
  UserAuthorityType,
} from 'entities/user/module'

import { LIST_UNAVAILABLE_EMAILS } from 'shared/constants'

const defaultUserAuthorityType: UserAuthorityType = 'BANK_CLIENT'

class UserStore {
  account: Account | null = null
  user_authority_type?: UserAuthorityType = defaultUserAuthorityType
  guest_has_favorites: boolean | null = null
  userSettings?: AppSettings | null = null
  client_state: Record<string, ClientStateValue> = {}

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  loginUser(data: Account) {
    if (data === null) return

    const userData = { ...data }

    if (
      data &&
      LIST_UNAVAILABLE_EMAILS.includes(String(userData?.email || '').trim())
    ) {
      userData.email = ''
    }

    this.account = userData
    this.guest_has_favorites = null
  }

  saveEmail(email: string) {
    const newData = this.account

    newData!.email = email

    this.account = newData
  }

  getAccountInfo() {
    return toJS(this.account)
  }

  setUserAuthorityType(userAuthorityType: UserAuthorityType) {
    this.user_authority_type = userAuthorityType
  }

  setGuestHasFavorites(hasFavorites: boolean) {
    this.guest_has_favorites = hasFavorites
  }

  setUserSettings(data?: AppSettings | null, isWidgetSearch?: boolean) {
    if (data === undefined) return

    this.userSettings = data

    if (!data) return

    const dataClientState = data.client_state || {}

    if (isWidgetSearch && dataClientState?.avia) dataClientState.avia = {}

    this.client_state = dataClientState
    this.setGuestHasFavorites(data?.has_favorites)
  }

  setClientStateValue(key: string, value: ClientStateValue) {
    this.client_state = {
      ...this.client_state,
      [key]: value,
    }

    if (this.userSettings) {
      this.userSettings = {
        ...this.userSettings,
        client_state: this.client_state,
      }
    }
  }

  getClientStateValue<T = ClientStateValue>(key: string): T | null {
    const value = this.client_state[key]

    if (value === undefined || value === null || value === '') return null

    return toJS(value) as T
  }

  getClientStateString(key: string) {
    const value = this.getClientStateValue(key)

    if (value === null) return ''
    if (typeof value === 'string') return value
    if (typeof value === 'boolean' || typeof value === 'number')
      return String(value)

    return JSON.stringify(value)
  }

  getClientStateParse<T>(key: string): T | null {
    const value = this.getClientStateValue(key)

    if (value === null) return null
    if (typeof value !== 'string') return value as T

    try {
      return JSON.parse(value) as T
    } catch {
      return null
    }
  }

  getUserSettings() {
    return this.userSettings
  }
}

export default new UserStore()
